import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ToolbarButton',
  props: {
    isActive: {
      type: Boolean,
      required: false,
    },
    icon: {
      type: Array as () => string[],
      required: true,
    },
  },
  emits: ['click'],
  setup(__props) {

  

  

return { __sfc: true, }
}

})